import { useState } from "react";
import { Vendor } from "../types";

export const useVendorForm = () => {
  const [selectedVendor, setSelectedVendor] = useState<Vendor | null>(null);
  const [isNew, setIsNew] = useState(false);

  const handleChange = (field: keyof Vendor, value: any) => {
    if (!selectedVendor) return;
    setSelectedVendor({ ...selectedVendor, [field]: value });
  };

  return { selectedVendor, setSelectedVendor, isNew, setIsNew, handleChange };
};
